import React from 'react';
import { Zap, Heart, Award, CheckCircle, MapPin, Users } from 'lucide-react';
import { advantages } from '../data/mock';

const iconMap = {
  Zap: Zap,
  Heart: Heart,
  Award: Award,
  CheckCircle: CheckCircle,
  MapPin: MapPin,
  Users: Users
};

const Advantages = () => {
  return (
    <section id="avantages" className="py-16 md:py-24 bg-gradient-to-b from-[#F8F8F5] to-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-[#4A6B96] mb-6">
            Pourquoi Choisir Esprit Ouest ?
          </h2>
          <p className="text-base md:text-xl text-gray-600">
            Des avantages pensés pour votre confort, votre productivité et votre réussite professionnelle.
          </p>
        </div>

        {/* Advantages Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {advantages.map((advantage, index) => {
            const IconComponent = iconMap[advantage.icon];
            return (
              <div
                key={advantage.id}
                className="group p-8 rounded-xl bg-[#F8F8F5] border-2 border-gray-200 hover:border-[#FFFFFF] hover:shadow-xl transition-all duration-300"
                style={{ animationDelay: `${index * 50}ms` }}
              >
                <div className="w-16 h-16 bg-gradient-to-br from-[#4A6B96] to-[#4A6B96]/80 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 group-hover:rotate-3 transition-all duration-300">
                  <IconComponent className="text-white font-bold" size={32} />
                </div>
                
                <h3 className="text-xl font-bold text-[#4A6B96] mb-3">
                  {advantage.title}
                </h3>
                
                <p className="text-gray-600 leading-relaxed">
                  {advantage.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Featured Section - All Inclusive */}
        <div className="premium-blue-card rounded-2xl overflow-hidden shadow-2xl">
          <div className="grid md:grid-cols-2">
            {/* Image */}
            <div className="h-80 md:h-auto">
              <img
                src="https://customer-assets.emergentagent.com/job_bureaux-prestige/artifacts/4f8y75fy_ChatGPT%20Image%205%20mai%202026%2C%2011_45_37.png"
                alt="Services Premium - Espace de coworking lumineux avec verrière et coin café"
                className="w-full h-full object-cover"
              />
            </div>

            {/* Content */}
            <div className="p-12 flex flex-col justify-center">
              <div className="inline-flex items-center space-x-2 bg-[#FFFFFF]/20 px-4 py-2 rounded-full mb-6 w-fit">
                <CheckCircle className="text-white font-bold" size={20} />
                <span className="text-sm font-medium text-white font-bold">Services</span>
              </div>

              <h3 className="text-3xl md:text-4xl font-bold text-white mb-6">
                Des Services Premium pour Votre Confort
              </h3>

              {/* Inclus */}
              <div className="mb-8">
                <h4 className="text-xl font-semibold text-white font-bold mb-4">Inclus</h4>
                <div className="space-y-3">
                  <div className="flex items-start space-x-3">
                    <CheckCircle className="text-white font-bold flex-shrink-0 mt-1" size={20} />
                    <p className="text-gray-300">
                      <span className="font-semibold text-white">Ménage Hebdomadaire</span>
                    </p>
                  </div>
                  <div className="flex items-start space-x-3">
                    <CheckCircle className="text-white font-bold flex-shrink-0 mt-1" size={20} />
                    <p className="text-gray-300">
                      <span className="font-semibold text-white">Charges</span>
                    </p>
                  </div>
                </div>
              </div>

              {/* En option */}
              <div className="mb-8">
                <h4 className="text-xl font-semibold text-white font-bold mb-4">En option</h4>
                <div className="space-y-3">
                  <div className="flex items-start space-x-3">
                    <div className="w-4 h-4 border-2 border-[#FFFFFF] rounded-full flex-shrink-0 mt-1"></div>
                    <p className="text-gray-300">
                      <span className="font-semibold text-white">Internet Haut Débit</span>
                    </p>
                  </div>
                  <div className="flex items-start space-x-3">
                    <div className="w-4 h-4 border-2 border-[#FFFFFF] rounded-full flex-shrink-0 mt-1"></div>
                    <p className="text-gray-300">
                      <span className="font-semibold text-white">Ameublement</span>
                    </p>
                  </div>
                </div>
              </div>

              <p className="text-white font-bold text-lg font-semibold">
                Des formules flexibles adaptées à vos besoins.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Advantages;
